<div class="block-header">
    <h3 class="block-header__title">{{ header }}</h3>
    <div class="block-header__divider"></div>
</div>
